export { default as ElementErrorBoundary } from './element-error-boundary';
